export { default } from './UnsupportedBrowserPrompt';
export * from './UnsupportedBrowserPrompt';
